/**
 * @file  popover浮层组件
 * @author liudy
 */

import React, { Component, createRef, CSSProperties, RefObject } from 'react';
import IPopover from './interface';
import Manager from './popoverManager';
import { isRTL } from '@umu/umu-util';
import './popover.scss';

export interface IProps {
    content?: string | JSX.Element;
    float?: 'left' | 'right'; // 左右
    position?: 'top' | 'botton'; // 上下
    isShowMask?: boolean;
    clsName?: string;
}

export interface IState {
    showContainer: boolean;
    containerHeight: number;
}

export default class Popover extends Component<IProps, IState> implements IPopover {
    public targetRef: RefObject<HTMLDivElement>;
    public manager: Manager;
    constructor(props: IProps) {
        super(props);
        this.state = {
            showContainer: false,
            containerHeight: 0,
        };

        this.targetRef = createRef();

        this.onPopover = this.onPopover.bind(this);

        this.manager = Manager.getManager();
        this.manager.addComponents(this);
    }

    public componentWillUnmount() {
        this.manager.removeComponents(this);
    }

    public onPopover(e: React.MouseEvent) {
        e.preventDefault();
        e.stopPropagation();
        // this.manager.currentPoppver = this;
        this.manager.hideAll();
        window.setTimeout(() => {
            this.show();
        }, 50);

        const targetEle = this.targetRef.current as HTMLDivElement;
        let height = 20; // 默认target的高度
        if (targetEle) {
            height = targetEle.clientHeight;
        }

        this.setState({
            showContainer: !this.state.showContainer,
            containerHeight: height,
        });

        return false;
    }

    public show() {
        this.setState({
            showContainer: true,
        });
        if (this.props.isShowMask) {
            this.manager.showMask();
        }
    }

    public hide() {
        this.setState({
            showContainer: false,
        });
        if (this.props.isShowMask) {
            this.manager.hideMask();
        }
    }

    public render() {
        const { content, children, clsName } = this.props;
        const style = this.getStyle(this.props.float, this.props.position);
        return (
            <div className={`popover ${clsName || ''}`}>
                <span className="popover-target" onClick={this.onPopover} ref={this.targetRef}>
                    {children}
                </span>
                <div className={`popover-container ${this.state.showContainer ? 'show' : 'hide'}`} style={style}>
                    {content}
                </div>
            </div>
        );
    }

    private getStyle(float: string = 'left', position: string = 'top') {
        const style: CSSProperties = {};
        if (float === 'left' && position === 'top') {
            style.left = 0;
            style.top = `${this.state.containerHeight + 10}px`;
            if (isRTL()) {
                style.left = 'auto';
                style.right = 0;
            }
        }

        if (float === 'right' && position === 'top') {
            style.right = 0;
            style.top = `${this.state.containerHeight + 10}px`;
            if (isRTL()) {
                style.right = 'auto';
                style.left = 0;
            }
        }

        if (float === 'left' && position === 'bottom') {
            style.left = 0;
            style.bottom = `${this.state.containerHeight + 10}px`;
            if (isRTL()) {
                style.left = 'auto';
                style.right = 0;
            }
        }

        if (float === 'right' && position === 'bottom') {
            style.right = 0;
            style.bottom = `${this.state.containerHeight + 10}px`;
            if (isRTL()) {
                style.right = 'auto';
                style.left = 0;
            }
        }

        return style;
    }
}
